import { HugeiconsIcon } from "@hugeicons/react";
import {
  Analytics01Icon,
  Calendar04Icon,
  UserMultiple02Icon,
  PaymentSuccess01Icon,
  File02Icon,
  Appointment02Icon,
  ArrowLeftRightIcon,
  BedDoubleIcon,
  UserMultiple03Icon,
  Stethoscope02Icon,
  HelpCircleIcon,
  ReceiptDollarIcon,
  Pickup01Icon,
  RotateClockwiseIcon,
  NaturalFoodIcon,
  PackageIcon,
  Refresh04Icon,
} from "@hugeicons/core-free-icons";
import { PATHS } from "../../constants/paths";
import { ROLES } from "../../constants/roles";
import { IconClipboardList, IconStethoscope } from "@tabler/icons-react";
import { getFacilityKind } from "../../helpers/cookies";

export default function links(role) {
  switch (role) {
    case ROLES.RECEPTIONIST:
      return [
        {
          label: "Dashboard",
          path: PATHS.RECEPTIONIST_DASHBOARD,
          activePaths: [PATHS.RECEPTIONIST_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Appointments",
          path: PATHS.RECEPTIONIST_APPOINTMENTS,
          activePaths: [
            PATHS.RECEPTIONIST_APPOINTMENTS,
            PATHS.ADD_RECEPTIONIST_APPOINTMENT,
          ],
          svg: <HugeiconsIcon icon={Calendar04Icon} />,
        },
        {
          label: "Patients",
          path: PATHS.RECEPTIONIST_PATIENTS,
          activePaths: [
            PATHS.RECEPTIONIST_PATIENTS,
            PATHS.VIEW_RECEPTIONIST_PATIENT,
          ],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
        {
          label: "Billings",
          path: PATHS.RECEPTIONIST_BILLINGS,
          activePaths: [PATHS.RECEPTIONIST_BILLINGS],
          svg: <HugeiconsIcon icon={PaymentSuccess01Icon} />,
        },
        {
          label: "Staff Status",
          path: PATHS.RECEPTIONIST_DOCTOR_STATUS,
          activePaths: [PATHS.RECEPTIONIST_DOCTOR_STATUS],
          svg: <IconStethoscope />,
        },
      ];
    case ROLES.PRE_OPD_MANAGEMENT:
      return [
        {
          label: "Assessments",
          path: PATHS.PRE_OPD_ASSESSMENTS,
          activePaths: [
            PATHS.PRE_OPD_ASSESSMENTS,
            PATHS.PRE_OPD_ASSESSMENTS_ADD,
            PATHS.PRE_OPD_ASSESSMENTS_EDIT,
            PATHS.PRE_OPD_ASSESSMENTS_VIEW,
          ],
          svg: <HugeiconsIcon icon={File02Icon} />,
        },
      ];
    case ROLES.DOCTOR:
      return [
        {
          label: "Dashboard",
          path: PATHS.DOCTOR_DASHBOARD,
          activePaths: [PATHS.DOCTOR_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Appointments",
          path: PATHS.DOCTOR_APPOINTMENTS,
          activePaths: [
            PATHS.DOCTOR_APPOINTMENTS,
            PATHS.VIEW_DOCTOR_APPOINTMENT,
          ],
          svg: <HugeiconsIcon icon={Appointment02Icon} />,
        },
        {
          label: "Prescriptions",
          path: PATHS.DOCTOR_PRESCRIPTIONS,
          activePaths: [
            PATHS.DOCTOR_PRESCRIPTIONS,
            PATHS.VIEW_DOCTOR_PRESCRIPTION,
            PATHS.ADD_DOCTOR_OPD_PRESCRIPTION,
            PATHS.ADD_DOCTOR_IPD_PRESCRIPTION,
            PATHS.OPD_PRESCRIPTION_SUMMARY,
            PATHS.IPD_PRESCRIPTION_SUMMARY,
            PATHS.VIEW_DHP,
          ],
          svg: <IconClipboardList strokeWidth={1.5} />,
        },
        {
          label: "AI Prescription Reviews",
          path: PATHS.DOCTOR_AI_PRESCRIPTION_REVIEWS,
          activePaths: [
            PATHS.DOCTOR_AI_PRESCRIPTION_REVIEWS,
            PATHS.VIEW_DOCTOR_AI_PRESCRIPTION,
            PATHS.EDIT_DOCTOR_AI_PRESCRIPTION,
          ],
          svg: <IconClipboardList strokeWidth={1.5} />,
        },
        {
          label: "Patient Dept",
          path: PATHS.DOCTOR_PATIENTS,
          activePaths: [PATHS.DOCTOR_PATIENTS, PATHS.VIEW_DOCTOR_PATIENT],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
        {
          label: "Finances",
          path: PATHS.DOCTOR_FINANCES,
          activePaths: [PATHS.DOCTOR_FINANCES],
          svg: <HugeiconsIcon icon={ReceiptDollarIcon} />,
        },
      ];
    case ROLES.FOLLOW_UP_MANAGEMENT:
      return [
        {
          label: "Follow-Up",
          path: PATHS.FOLLOW_UP_LIST,
          activePaths: [PATHS.FOLLOW_UP_LIST],
          svg: <HugeiconsIcon icon={Calendar04Icon} />,
        },
      ];
    case ROLES.COUNSELLOR:
      return [
        {
          label: "Dashboard",
          path: PATHS.COUNSELLOR_DASHBOARD,
          activePaths: [PATHS.COUNSELLOR_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "OPD Patients",
          path: PATHS.COUNSELLOR_OPD_PATIENTS,
          activePaths: [
            PATHS.COUNSELLOR_OPD_PATIENTS,
            PATHS.COUNSELLOR_OPD_VIEW,
            PATHS.COUNSELLOR_IPD_VIEW,
            PATHS.COUNSELLOR_ITEM_INFO,
          ],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
        {
          label: "Invoices",
          path: PATHS.COUNSELLOR_INVOICES,
          activePaths: [
            PATHS.COUNSELLOR_INVOICES,
            PATHS.COUNSELLOR_TAKE_PAYMENT,
            PATHS.COUNSELLOR_PAYMENT_CONFIRM,
            PATHS.COUNSELLOR_VIEW_INVOICE,
            PATHS.COUNSELLOR_PRINT_INVOICE,
            PATHS.COUNSELLOR_CREATE_INVOICE,
          ],
          activePathPrefixes: [PATHS.COUNSELLOR_INVOICES],
          svg: <HugeiconsIcon icon={PaymentSuccess01Icon} />,
        },
      ];
    case ROLES.NURSE:
      return [
        {
          label: "Dashboard",
          path: PATHS.NURSE_DASHBOARD,
          activePaths: [PATHS.NURSE_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "IPD Patients",
          path: PATHS.NURSE_IPD_PATIENTS,
          activePaths: [
            PATHS.NURSE_IPD_PATIENTS,
            PATHS.NURSE_IPD_PATIENTS_VIEW,
          ],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
      ];
    case ROLES.IPD_MANAGEMENT:
      return [
        {
          label: "Dashboard",
          path: PATHS.IPD_DASHBOARD,
          activePaths: [PATHS.IPD_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Transfers",
          path: PATHS.IPD_TRANSFERS,
          activePaths: [
            PATHS.IPD_TRANSFERS,
            PATHS.ADMIT_IPD_PATIENT,
            PATHS.VIEW_IPD_PRESCRIPTION,
          ],
          svg: <HugeiconsIcon icon={ArrowLeftRightIcon} />,
        },
        {
          label: "IPD Patients",
          path: PATHS.IPD_USERS,
          activePaths: [
            PATHS.IPD_USERS,
            PATHS.VIEW_IPD_USER,
            PATHS.DISCHARGE_IPD_USER,
          ],
          svg: <HugeiconsIcon icon={UserMultiple03Icon} />,
        },
        {
          label: "Procedures",
          path: PATHS.IPD_PROCEDURES,
          activePaths: [
            PATHS.IPD_PROCEDURES,
            PATHS.ADD_IPD_PROCEDURE,
            PATHS.EDIT_IPD_PROCEDURE,
            PATHS.VIEW_IPD_PROCEDURE,
          ],
          svg: <HugeiconsIcon icon={Stethoscope02Icon} />,
        },
        {
          label: "Rooms",
          path: PATHS.IPD_ROOMS,
          activePaths: [PATHS.IPD_ROOMS, PATHS.VIEW_IPD_ROOM],
          svg: <HugeiconsIcon icon={BedDoubleIcon} />,
        },
        {
          label: "Billings",
          path: PATHS.IPD_BILLINGS,
          activePaths: [PATHS.IPD_BILLINGS, PATHS.GENERATE_IPD_BILLING],
          svg: <HugeiconsIcon icon={ReceiptDollarIcon} />,
        },
        {
          label: "Documents",
          path: PATHS.IPD_TEMPLATES,
          activePaths: [PATHS.IPD_TEMPLATES],
          svg: <HugeiconsIcon icon={File02Icon} />,
        },
        {
          label: "Agent Knowledge Base",
          path: PATHS.IPD_KNOWLEDGE,
          activePaths: [PATHS.IPD_KNOWLEDGE, PATHS.VIEW_IPD_KNOWLEDGE],
          svg: <HugeiconsIcon icon={HelpCircleIcon} />,
        },
        {
          label: "Inventory",
          path: PATHS.IPD_INVENTORY,
          activePaths: [PATHS.IPD_INVENTORY, PATHS.IPD_INVENTORY_REQUESTS],
          svg: <HugeiconsIcon icon={PackageIcon} />,
        },
      ];
    case ROLES.PHARMACIST:
      return [
        {
          label: "Dashboard",
          path: PATHS.PHARMACIST_DASHBOARD,
          activePaths: [PATHS.PHARMACIST_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Patients List",
          path: PATHS.PHARMACIST_PATIENTS,
          activePaths: [PATHS.PHARMACIST_PATIENTS],
          activePathPrefixes: [PATHS.PHARMACIST_PATIENTS],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
        {
          label: "OTC invoices",
          path: PATHS.PHARMACIST_OTC_INVOICES,
          activePaths: [PATHS.PHARMACIST_OTC_INVOICES],
          svg: <HugeiconsIcon icon={ReceiptDollarIcon} />,
        },
        {
          label: "Inventory",
          path: PATHS.PHARMACIST_INVENTORY,
          activePaths: [
            PATHS.PHARMACIST_INVENTORY,
            PATHS.PHARMACIST_INVENTORY_VIEW,
            PATHS.PHARMACIST_INVENTORY_BULK_UPDATE,
          ],
          svg: <HugeiconsIcon icon={PackageIcon} />,
        },
        {
          label: "Orders",
          path: PATHS.PHARMACIST_ORDERS,
          activePaths: [PATHS.PHARMACIST_ORDERS],
          activePathPrefixes: [PATHS.PHARMACIST_ORDERS],
          svg: <IconClipboardList />,
        },
      ];

    case ROLES.RADIOLOGIST:
      return [
        {
          label: "Dashboard",
          path: PATHS.RADIOLOGIST_DASHBOARD,
          activePaths: [PATHS.RADIOLOGIST_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Bookings",
          path: PATHS.RADIOLOGIST_BOOKINGS,
          activePaths: [
            PATHS.RADIOLOGIST_BOOKINGS,
            PATHS.VIEW_RADIOLOGIST_BOOKING,
          ],
          svg: <HugeiconsIcon icon={Appointment02Icon} />,
        },
      ];

    case ROLES.LAB_TEST:
      return [
        {
          label: "Dashboard",
          path: PATHS.LAB_TEST_DASHBOARD,
          activePaths: [PATHS.LAB_TEST_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Bookings",
          path: PATHS.LAB_TEST_BOOKINGS,
          activePaths: [PATHS.LAB_TEST_BOOKINGS, PATHS.VIEW_LAB_TEST_BOOKING],
          svg: <HugeiconsIcon icon={Appointment02Icon} />,
        },
        {
          label: "Pickups",
          path: PATHS.LAB_TEST_PICKUPS,
          activePaths: [PATHS.LAB_TEST_PICKUPS],
          svg: <HugeiconsIcon icon={Pickup01Icon} />,
        },
      ];

    case ROLES.THERAPIST:
      return [
        {
          label: "Dashboard",
          path: PATHS.THERAPIST_DASHBOARD,
          activePaths: [PATHS.THERAPIST_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Appointments",
          path: PATHS.THERAPIST_APPOINTMENTS,
          activePaths: [
            PATHS.THERAPIST_APPOINTMENTS,
            PATHS.THERAPIST_APPOINTMENT_VIEW,
            PATHS.THERAPIST_APPOINTMENT_PRESCRIPTION,
            PATHS.THERAPIST_APPOINTMENT_DHP,
            PATHS.THERAPIST_APPOINTMENT_ADD_THERAPY,
          ],
          activePathPrefixes: [PATHS.THERAPIST_APPOINTMENTS],
          svg: <HugeiconsIcon icon={Appointment02Icon} />,
        },
        {
          label: "In Patient dept.",
          path: PATHS.THERAPIST_IN_PATIENT_DEPT,
          activePaths: [
            PATHS.THERAPIST_IN_PATIENT_DEPT,
            PATHS.THERAPIST_IN_PATIENT_DEPT_VIEW,
            PATHS.THERAPIST_IN_PATIENT_DEPT_DHP,
            PATHS.THERAPIST_IN_PATIENT_DEPT_ADD_THERAPY,
          ],
          activePathPrefixes: [PATHS.THERAPIST_IN_PATIENT_DEPT],
          svg: <HugeiconsIcon icon={BedDoubleIcon} />,
        },
        {
          label: "Inventory",
          path: PATHS.THERAPIST_INVENTORY,
          activePaths: [
            PATHS.THERAPIST_INVENTORY,
            PATHS.THERAPIST_INVENTORY_REQUESTS,
          ],
          svg: <HugeiconsIcon icon={PackageIcon} />,
        },
      ];

    case ROLES.YOGA: {
      const facilityKind = getFacilityKind();
      const yogaLinks = [
        {
          label: "Dashboard",
          path: PATHS.YOGA_DASHBOARD,
          activePaths: [PATHS.YOGA_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Business Dashboard",
          path: PATHS.YOGA_BUSINESS_DASHBOARD,
          activePaths: [PATHS.YOGA_BUSINESS_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
          facilityKinds: ["yoga_studio"],
        },
        {
          label: "Appointments",
          path: PATHS.YOGA_APPOINTMENTS,
          activePaths: [
            PATHS.YOGA_APPOINTMENTS,
            PATHS.VIEW_YOGA_APPOINTMENT,
            PATHS.YOGA_APPOINTMENT_PRESCRIPTION,
            PATHS.YOGA_APPOINTMENT_DHP,
          ],
          activePathPrefixes: [PATHS.YOGA_APPOINTMENTS],
          svg: <HugeiconsIcon icon={Appointment02Icon} />,
        },
        {
          label: "In Patient dept.",
          path: PATHS.YOGA_IN_PATIENT_DEPT,
          activePaths: [
            PATHS.YOGA_IN_PATIENT_DEPT,
            PATHS.VIEW_YOGA_IN_PATIENT_DEPT,
            PATHS.YOGA_IN_PATIENT_DEPT_DHP,
          ],
          svg: <HugeiconsIcon icon={BedDoubleIcon} />,
          facilityKinds: ["hospital"],
        },
        {
          label: "Payment Invoices",
          path: PATHS.YOGA_PAYMENT_INVOICES,
          activePaths: [PATHS.YOGA_PAYMENT_INVOICES],
          svg: <HugeiconsIcon icon={ReceiptDollarIcon} />,
        },
        {
          label: "Finances",
          path: PATHS.YOGA_FINANCES,
          activePaths: [PATHS.YOGA_FINANCES],
          svg: <HugeiconsIcon icon={PaymentSuccess01Icon} />,
          facilityKinds: ["yoga_studio"],
        },
        {
          label: "Sessions",
          path: PATHS.YOGA_SESSIONS,
          activePaths: [
            PATHS.YOGA_SESSIONS,
            PATHS.VIEW_YOGA_SESSION_GROUP,
            PATHS.VIEW_YOGA_SESSION_ONE_ON_ONE,
            PATHS.VIEW_YOGA_SESSION_RECORDED,
            PATHS.YOGA_SESSION_GROUP_FORM,
            PATHS.YOGA_SESSION_RECORDED_FORM,
            PATHS.YOGA_SESSION_ONE_ON_ONE_FORM,
            PATHS.YOGA_SESSION_GROUP_EDIT_FORM,
            PATHS.YOGA_SESSION_RECORDED_EDIT_FORM,
            PATHS.YOGA_SESSION_ONE_ON_ONE_EDIT_FORM,
          ],
          activePathPrefixes: [PATHS.YOGA_SESSIONS],
          svg: <HugeiconsIcon icon={Calendar04Icon} />,
        },
      ];
      return yogaLinks.filter(
        (link) =>
          !link.facilityKinds || link.facilityKinds.includes(facilityKind),
      );
    }
    case ROLES.BILLING_MANAGER:
      return [
        {
          label: "Dashboard",
          path: PATHS.BILLING_MANAGER_DASHBOARD,
          activePaths: [PATHS.BILLING_MANAGER_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Service Providers",
          path: PATHS.BILLING_MANAGER_PROVIDERS,
          activePaths: [
            PATHS.BILLING_MANAGER_PROVIDERS,
            PATHS.VIEW_BILLING_MANAGER_PROVIDER,
            PATHS.VIEW_BILLING_MANAGER_PROVIDER_INVOICE,
          ],
          svg: <HugeiconsIcon icon={UserMultiple03Icon} />,
        },
        {
          label: "Invoices",
          path: PATHS.BILLING_MANAGER_INVOICES,
          activePaths: [
            PATHS.BILLING_MANAGER_INVOICES,
            PATHS.VIEW_BILLING_MANAGER_INVOICE,
            PATHS.PAYMENT_BILLING_MANAGER_INVOICE,
          ],
          svg: <HugeiconsIcon icon={ReceiptDollarIcon} />,
        },
        {
          label: "Refunds",
          path: PATHS.BILLING_MANAGER_REFUNDS,
          activePaths: [
            PATHS.BILLING_MANAGER_REFUNDS,
            PATHS.VIEW_BILLING_MANAGER_REFUND,
          ],
          svg: <HugeiconsIcon icon={RotateClockwiseIcon} />,
        },
      ];

    case ROLES.DIETICIAN:
      return [
        {
          label: "Dashboard",
          path: PATHS.DIETICIAN_DASHBOARD,
          activePaths: [PATHS.DIETICIAN_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Appointments",
          path: PATHS.DIETICIAN_APPOINTMENTS,
          activePaths: [
            PATHS.DIETICIAN_APPOINTMENTS,
            PATHS.VIEW_DIETICIAN_APPOINTMENT,
            PATHS.DIETICIAN_APPOINTMENT_DHP,
            PATHS.ADD_DIETICIAN_PRESCRIPTION,
            PATHS.VIEW_DIETICIAN_PRESCRIPTION,
          ],
          svg: <HugeiconsIcon icon={Appointment02Icon} />,
        },
        {
          label: "Diet Management",
          path: PATHS.DIETICIAN_PLANS,
          activePaths: [
            PATHS.DIETICIAN_PLANS,
            PATHS.VIEW_DIETICIAN_PLAN,
            PATHS.ADD_DIETICIAN_PLAN,
            PATHS.EDIT_DIETICIAN_PLAN,
          ],
          svg: <HugeiconsIcon icon={NaturalFoodIcon} />,
        },
        {
          label: "In Patient department",
          path: PATHS.DIETICIAN_IPDS,
          activePaths: [
            PATHS.DIETICIAN_IPDS,
            PATHS.DIETICIAN_IPD_VIEW,
            PATHS.DIETICIAN_IPD_DHP,
          ],
          svg: <HugeiconsIcon icon={BedDoubleIcon} />,
        },
      ];

    case ROLES.STAFF_MANAGER:
      return [
        {
          label: "Staff Management",
          path: PATHS.STAFF_MANAGER_STAFF,
          activePaths: [
            PATHS.STAFF_MANAGER_STAFF,
            PATHS.STAFF_MANAGER_STAFF_VIEW,
            PATHS.STAFF_MANAGER_ADD_STAFF,
            PATHS.STAFF_MANAGER_ADD_SLOTS,
            PATHS.STAFF_MANAGER_EDIT_SLOTS,
            PATHS.STAFF_MANAGER_EDIT_STAFF,
          ],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
      ];
    case ROLES.STORE_MANAGER:
      return [
        {
          label: "Dashboard",
          path: PATHS.STORE_MANAGER_DASHBOARD,
          activePaths: [PATHS.STORE_MANAGER_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Products Inventory",
          path: PATHS.STORE_MANAGER_PRODUCTS,
          activePaths: [
            PATHS.STORE_MANAGER_PRODUCTS,
            PATHS.VIEW_STORE_MANAGER_PRODUCT,
            PATHS.ADD_STORE_MANAGER_PRODUCT,
            PATHS.EDIT_STORE_MANAGER_PRODUCT,
            PATHS.ADD_STORE_MANAGER_BULK_PRODUCT,
          ],
          svg: <HugeiconsIcon icon={PackageIcon} />,
        },
        {
          label: "Services Inventory",
          path: PATHS.STORE_MANAGER_SERVICES,
          activePaths: [
            PATHS.STORE_MANAGER_SERVICES,
            PATHS.VIEW_STORE_MANAGER_SERVICE,
            PATHS.ADD_STORE_MANAGER_SERVICE,
            PATHS.EDIT_STORE_MANAGER_SERVICE,
            PATHS.ADD_STORE_MANAGER_BULK_SERVICE,
          ],
          svg: <HugeiconsIcon icon={PackageIcon} />,
        },
        {
          label: "Stock Inventory",
          path: PATHS.STORE_MANAGER_INVENTORY,
          activePaths: [
            PATHS.STORE_MANAGER_INVENTORY,
            PATHS.VIEW_STORE_MANAGER_INVENTORY,
            PATHS.STORE_MANAGER_ASSIGNMENT_HISTORY,
          ],
          svg: <HugeiconsIcon icon={PackageIcon} />,
        },
        {
          label: "Refill Requests",
          path: PATHS.STORE_MANAGER_REQUESTS,
          activePaths: [
            PATHS.STORE_MANAGER_REQUESTS,
            PATHS.VIEW_STORE_MANAGER_REQUEST,
          ],
          svg: <HugeiconsIcon icon={Refresh04Icon} />,
        },
      ];

    case ROLES.ADMIN:
      return [
        {
          label: "Admin Dashboard",
          path: PATHS.ADMIN_DASHBOARD,
          activePaths: [PATHS.ADMIN_DASHBOARD],
          svg: <HugeiconsIcon icon={Analytics01Icon} />,
        },
        {
          label: "Stakeholders",
          path: PATHS.ADMIN_STAKEHOLDERS,
          activePaths: [PATHS.ADMIN_STAKEHOLDERS],
          svg: <HugeiconsIcon icon={UserMultiple02Icon} />,
        },
      ];

    default:
      return [
        {
          label: "Select Role",
          path: PATHS.ROLES,
          activePaths: [PATHS.ROLES],
          svg: <HugeiconsIcon icon={UserMultiple03Icon} />,
        },
      ];
  }
}
